import React, { useState } from 'react'

function FileuploadInput({ name, onChange, accept }) {
    const [error, setError] = useState(false)
    const [fileSize, setFileSize] = useState(false)
    const [fileName, setFileName] = useState()
    const [file, setFile] = useState(null)

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the selected file
        setFile(file)

        const fileSizeMB = file.size / 1024 / 1024;
        const fileSizeGB = file.size / 1024 / 1024 / 1024;
        setFileSize(fileSizeGB > 1 ? `${fileSizeGB.toFixed(2)} GB` : `${fileSizeMB.toFixed(2)} MB`);
        setFileName(file.name)

        if (file) {
            // Split the accept attribute by comma and trim spaces
            const validTypes = accept.split(',').map(type => type.trim());
            // Check if the file's MIME type is included in the valid types
            if (!validTypes.includes(file.type)) {
                setError('Invalid file type');
                e.target.value = null; // Clear the input
                return;
            } else {
                setError(''); // Clear error message if file is valid
                onChange(e); // Pass the valid file to the parent component
            }
        }
    }


    const unSelsctImage = () => {
        setFile(null)
        setFileName('')
        setFileSize('')
    }

    return (
        <>
            {/* <div className="flex flex-col">

                <input
                    onChange={handleFileChange}
                    name={name}
                    type="file"
                    accept={accept}
                    placeholder={placeholder}
                    className="w-full font-poppins md:w-[500px] rounded-lg text-gray-500 font-medium text-sm bg-gray-100 file:cursor-pointer cursor-pointer file:border-0 file:py-2 file:px-4 file:mr-4 file:bg-gray-900 file:hover:bg-black file:text-white rounded"
                />

                <div className='flex flex-row'>
                    {error && <span className="text-[13px] ml-1 text-red-400 font-poppins">{error}</span>}
                    {fileSize && !error && <span className="text-[13px]  ml-1 text-green-400 font-poppins">File Size: {fileSize}</span>}
                </div>
            </div> */}



            <div class="grid gap-1 mb-3">
                <p class="flex text-center text-gray-400 justify-start   text-xs font-normal leading-4">Attach one image at a time, total file size may not exceed 25 MB (Only .jpeg and .png files)</p>
            </div>
            <label>
                <div class="mb-5 w-full h-11 rounded-3xl border border-gray-300 justify-start items-center inline-flex">

                    <div class="flex w-28 h-11 px-2 ml-[-1px] flex-col bg-indigo-600 rounded-l-3xl shadow text-white text-xs font-semibold leading-4 
                                             items-start justify-center cursor-pointer focus:outline-none">Choose image </div>
                    <input
                        hidden
                        onChange={handleFileChange}
                        name={name}
                        type="file"
                        accept={accept}
                    />

                    <div className='flex flex-row'>
                        {error && <span className="text-[13px] ml-1 text-red-400 font-poppins">{error}</span>}
                        {fileSize && !error && <span className="text-[13px]  ml-1 text-green-400 font-poppins">{fileName}</span>}
                    </div>

                </div>
            </label>

            {fileName && !error && (
                <div class="w-full grid gap-1">
                    <div class="flex items-center justify-between gap-2">
                        <div class="flex items-center gap-2">
                            <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.58487 19L7.07189 15.2455C7.69252 14.4869 8.00284 14.1076 8.40938 14.0633C8.47386 14.0563 8.53887 14.0555 8.60349 14.0611C9.01094 14.0961 9.32986 14.4682 9.9677 15.2123C10.6306 15.9857 10.962 16.3723 11.381 16.4005C11.4473 16.4049 11.5139 16.4027 11.5797 16.394C11.996 16.3387 12.3016 15.9312 12.9127 15.1164L14.3606 13.1858C15.11 12.1867 15.4847 11.6871 15.9919 11.693C16.4992 11.6989 16.8622 12.207 17.5881 13.2233L21 18M21 18V11C21 7.22876 21 5.34315 19.8284 4.17157C18.6569 3 16.7712 3 13 3H11C7.22876 3 5.34315 3 4.17157 4.17157C3 5.34315 3 7.22876 3 11V13C3 16.7712 3 18.6569 4.17157 19.8284C5.34315 21 7.22876 21 11 21H18C19.6569 21 21 19.6569 21 18Z" stroke="#4F46E5" stroke-width="1.7" class="my-path"></path>
                                <path d="M12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9Z" stroke="#000000" stroke-width="1.7" class="my-path"></path>
                            </svg>
                            <div class="grid gap-1">
                                <h4 class="text-gray-400 text-sm font-normal leading-snug">{fileName}</h4>
                                <h5 class="text-gray-400   text-xs font-normal leading-4">{fileSize}</h5>
                            </div>
                        </div>
                        <svg onClick={unSelsctImage} className='cursor-pointer' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g id="Upload 3">
                                <path id="icon" d="M15 9L12 12M12 12L9 15M12 12L9 9M12 12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#D1D5DB" stroke-width="1.6" stroke-linecap="round" />
                            </g>
                        </svg>
                    </div>
                </div>
            )}


        </>
    )
}

export default FileuploadInput;